import innagoGateWay from "../../services/authorizationService";
import serviceEndpoints from "../../config/serviceEndpoints";

export const getCardPositions = () => innagoGateWay.get(serviceEndpoints.dashboardEndPoints.getCardPosition);

export const updateCardPositions = (data) => innagoGateWay.put(serviceEndpoints.dashboardEndPoints.getCardPosition, data);

export const makeMultiplePayment = (data) => innagoGateWay.post(serviceEndpoints.dashboardEndPoints.makePayment, data);
